import { BaseService } from "mrb/core";
import { CouponApiRouteService } from "common/services";

class CouponService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new CouponApiRouteService());
    }

    validatePromoCode(promoCode, subscriptionProductId, abortSignal = null) {
        const url = this.routeService.validatePromoCode();
        return this.apiClient.post(url, { promoCode, subscriptionProductId }, null, abortSignal);
    }

    validateSignupPromoCode(promoCode, abortSignal = null) {
        const url = this.routeService.validateSignupPromoCode();
        return this.apiClient.post(url, { promoCode }, null, abortSignal);
    }
}

export default CouponService;
